import React from 'react';
import { ShieldCheckIcon, ClockIcon } from 'lucide-react';
import { CTAButton } from '../shared/CTAButton';
import { Reveal } from '../shared/Section';
export function Offer() {
  return <section id="oferta" className="w-full bg-forest-700 px-5 py-16 sm:py-24" data-id="element-144" data-mp="307iydpizafrq">
      <Reveal data-id="element-145" data-mp="309lwkwuabf7j">
        <div className="mx-auto max-w-2xl" data-id="element-146" data-mp="35642w159jllz">
          <div className="mb-6 text-center" data-id="element-147" data-mp="357x95fbys3tg">
            <span className="inline-flex items-center gap-2 rounded-full bg-clay-500/15 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-clay-400" data-id="element-148" data-mp="3a5gpqlw4wsok">
              <ClockIcon className="h-3.5 w-3.5" data-id="element-149" data-mp="3f2p7wmha8wpt" />
              Cupos limitados — Precio de lanzamiento
            </span>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white p-7 text-center shadow-2xl shadow-black/20 sm:p-10" data-id="element-150" data-mp="3nwls3vqvzz2l">
            <h2 className="font-display text-3xl font-semibold leading-tight text-forest-800 sm:text-4xl" data-id="element-151" data-mp="3swq00xdqblh7">
              Empezá tu transformación hoy
            </h2>
            <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-forest-700/70 sm:text-base" data-id="element-152" data-mp="1klgmuoak4klz">
              6 módulos de conocimiento puro + 3 bonos de regalo. Todo lo que necesitás para
              moverte sin dolor desde tu casa.
            </p>

            <div className="my-8" data-id="element-153" data-mp="1bl1yth67kres">
              <p className="text-sm font-medium uppercase tracking-wider text-clay-600" data-id="element-154" data-mp="16lp3e819uc0l">
                Precio especial
              </p>
              <p className="mt-1 font-display text-6xl font-bold text-forest-800" data-id="element-155" data-mp="23awo5du2gh3g">$22.990</p>
              <p className="mt-2 text-sm text-forest-700/60" data-id="element-156" data-mp="1zbfhih2wldwp">💳 Pago con Mercado Pago</p>
            </div>

            <CTAButton size="lg" href="https://movete-bien.impultienda.ar/checkout" className="w-full sm:w-auto" data-id="element-157" data-mp="1uimf3zuwqhns">
              QUIERO EL PROGRAMA
            </CTAButton>

            <p className="mt-6 flex items-center justify-center gap-2 text-sm font-medium text-forest-700" data-id="element-158" data-mp="2n19tyxjb90gf">
              <ShieldCheckIcon className="h-5 w-5 text-forest-500" data-id="element-159" data-mp="2i75luayb6mdr" />
              Garantía de 30 días — sin preguntas ni vueltas
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}